import { ReactNode, useState } from 'react';
import { Button } from '../../../../../components/form/button';
import Icon from '../../../../../components/icons/icon';
import { ConfirmModal } from '../../../../../components/modal/confirm-modal';

export const ProductItemDelete = ({
  id,
  isEditing,
  onDelete,
}: {
  id: string;
  isEditing: boolean;
  onDelete: (id: string) => void;
}) => {
  const [modal, setModal] = useState<ReactNode>(null);

  if (!isEditing) return null;

  return (
    <>
      <Button
        className="button button-tertiary !p-0 !m-0"
        onClick={() => {
          setModal(
            <ConfirmModal
              isOpen
              close={() => setModal(null)}
              onConfirm={() => onDelete(id)}
              headerIcon={
                <div className="flex justify-center">
                  <Icon icon="InfoCircle" size="xlarge" stroke="var(--error-500)" />
                </div>
              }
              prompt="Are you sure you want to delete this item?"
              noLabel="Cancel"
              yesLabel="Delete"
              yesDataCy="delete-item-confirm"
              yesButtonYellow
            />,
          );
        }}
        dataCy="delete-item-button"
      >
        <Icon icon="Trash" size="medium" />
      </Button>
      {modal}
    </>
  );
};
